​<div class="mcd-left-panel">
  <div class="mcd-side-nav-header">
    <button class="side-nav close-button material-icons">close</button>
  </div>
  <mat-card class="mcd-nav-card">
    <!-- <mat-card-header>
      <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text"></mat-card-title>
      </div>
    </mat-card-header> -->
    <mat-card-content>
      <!-- New Accordian Style left menu %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
     ************************************************************
     _________________+++++++++++++++++++++++++++___________
     ========================================================================== -->
      <div>
        <ul class="mcd-nav-list clearfix" *ngIf="
            viewAllGrsStandard ||
            showLocation ||
            canAddNewGrs ||
            showAddNewEquipment
          ">
          <li *ngIf="showLocation" style="padding: 0">
            <a class="" routerLink="/locations" routerLinkActive="active" ] (click)="goToHome()" style="display: flex">
              <img src="../../../assets/images/home 2 (1).svg" alt=" Standards" />
              <!-- <span class="nav-icon mcd-location"></span> -->
              <span class="nav-text" style="font-size: 14px; margin-left: 8px">Home</span>
            </a>
          </li>
        </ul>
      </div>

      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('standards')" tabindex="0">
            <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
            <div>
              <img src="../../../assets/images/shield-check 2.svg" alt=" Standards" class="accordian-item-heading" />
              <span>Standards</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Standards" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'standards'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'
                " />
            </span>
          </button>
          @if (expandedAccordion === "standards") {
          <ul class="mcd-nav-list clearfix" *ngIf="
                viewAllGrsStandard ||
                showLocation ||
                canAddNewGrs ||
                showAddNewEquipment
              ">
            <!-- <li  *ngIf="showLocation">
          <a
            class=""
            routerLink="/locations"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/locations')"
          >
            <span class="nav-icon mcd-location"></span>
            <span class="nav-text">Home</span>
          </a>
        </li> -->

            <li *ngIf="canAddNewGrs">
              <a class="" routerLink="/add-grs" href="javascript:void(0)" (click)="navigateMenu('/add-grs', 'add-grs')"
                [class.active]="lastSelectedMenu === 'add-grs'">
                <!-- <span class="nav-icon mcd-add-new-grbes"></span> -->
                <span class="nav-text">Add New System Standard</span>
              </a>
            </li>

            <li *ngIf="viewAllGrsStandard">
              <a class="" routerLink="/view-all-standards"
                (click)="navigateMenu('/view-all-standards', 'View All Standards')"
                [class.active]="lastSelectedMenu === 'View All Standards'">
                <!-- <span class="nav-icon mcd-view-all-min-standards"></span> -->
                <span class="nav-text">View All Standards</span>
              </a>
            </li>

            <!-- <li class="col-4" *ngIf="viewAllGrsStandard">
          <a
            class=""
            routerLink="/view-all-minimum-standard"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-minimum-standard')"
          >
            <span class="nav-icon mcd-view-all-min-standards"></span>
            <span class="nav-text">View All Building Standards</span>
          </a>
        </li> -->
            <!-- <li class="col-4" *ngIf="viewEquipmentGlobalStandard">
          <a
            class=""
            routerLink="/view-equipments-standard-list"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-equipments-standard-list')"
          >
            <span class="nav-icon mcd-view-all-equipment-standards"></span>
            <span class="nav-text">View All Equipment Standards</span>
          </a>
        </li> -->
            <!-- <li class="col-4" *ngIf="viewOperationsStandard">
          <a
            class=""
            routerLink="/view-all-operations-standards"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-operations-standards')"
          >
            <span class="nav-icon mcd-view-all-operations-standards"></span>
            <span class="nav-text">View All Operations Standards</span>
          </a>
        </li> -->

            <!-- <li class="col-4" *ngIf="viewAllSharedLearningsBestPractices">
          <a
            class=""
            routerLink="/view-all-global-recommendations"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="
              resetFilteration('/view-all-global-recomendations-standard')
            "
          >
            <span class="nav-icon mcd-view-all-min-standards"></span>
            <span class="nav-text">View Global Approved Solutions</span>
          </a>
        </li> -->
            <li *ngIf="viewFutureStandard">
              <a class="" routerLink="/view-all-upcoming-standards-list" href="javascript:void(0)"
                (click)="navigateMenu('/view-all-upcoming-standards-list', 'View All Upcoming Standards')"
                [class.active]="lastSelectedMenu === 'View All Upcoming Standards'">
                <!-- <span class="nav-icon mcd-view-all-upcoming-standards"></span> -->
                <span class="nav-text">View All Upcoming Standards</span>
              </a>
            </li>

          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>

      <!-- <ul
        class="mcd-nav-list clearfix"
        *ngIf="
          viewAllGrsStandard ||
          showLocation ||
          canAddNewGrs ||
          showAddNewEquipment
        "
      >
        <li class="col-4" *ngIf="showLocation">
          <a
            class=""
            routerLink="/locations"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/locations')"
          >
            <span class="nav-icon mcd-location"></span>
            <span class="nav-text">Home</span>
          </a>
        </li>

        <li class="col-4" *ngIf="canAddNewGrs">
          <a
            class=""
            routerLink="/add-grs"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/add-grs')"
          >
            <span class="nav-icon mcd-add-new-grbes"></span>
            <span class="nav-text">Add New System Standard</span>
          </a>
        </li>
        <li class="col-4" *ngIf="canAddEquipmentStandard">
          <a
            class=""
            routerLink="/add-eq-standards-global"
            (click)="resetFilteration('/add-eq-standards-global')"
          >
            <span class="nav-icon mcd-add-new-equipment"></span>
            <span class="nav-text">Add New Equipment Standard</span>
          </a>
        </li>
        <li class="col-4" *ngIf="viewAllGrsStandard">
          <a
            class=""
            routerLink="/view-all-standards"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-minimum-standard')"
          >
            <span class="nav-icon mcd-view-all-min-standards"></span>
            <span class="nav-text">View All Standards</span>
          </a>
        </li>

      


        <li class="col-4" *ngIf="viewFutureStandard">
          <a
            class=""
            routerLink="/view-all-upcoming-standards-list"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-upcoming-standards-list')"
          >
            <span class="nav-icon mcd-view-all-upcoming-standards"></span>
            <span class="nav-text">View All Upcoming Standards</span>
          </a>
        </li>
        <li class="col-4" *ngIf="viewEquipmentObsoleteStandard">
          <a
            class=""
            routerLink="/view-all-obsolete-standards-list"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-obsolete-standards-list')"
          >
            <span class="nav-icon mcd-view-all-obsolete-standards"></span>
            <span class="nav-text">View All Obsolete Equipment</span>
          </a>
        </li>
      </ul> -->
    </mat-card-content>
  </mat-card>

  <!-- <mat-card class="mcd-nav-card">
    <mat-card-header>
      <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text"
          >Additional Information</mat-card-title
        >
      </div>
    </mat-card-header>
    <mat-card-content>
      <ul class="mcd-nav-list clearfix">
        <li class="col-4" *ngIf="viewFutureStandard">
          <a
            class=""
            routerLink="/view-all-upcoming-standards-list"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-upcoming-standards-list')"
          >
            <span class="nav-icon mcd-view-all-upcoming-standards"></span>
            <span class="nav-text">View All Upcoming Standards</span>
          </a>
        </li>
        <li class="col-4" *ngIf="viewEquipmentObsoleteStandard">
          <a
            class=""
            routerLink="/view-all-obsolete-standards-list"
            routerLinkActive="active"
            href="javascript:void(0)"
            (click)="resetFilteration('/view-all-obsolete-standards-list')"
          >
            <span class="nav-icon mcd-view-all-obsolete-standards"></span>
            <span class="nav-text">View All Obsolete Equipment</span>
          </a>
        </li>
      </ul>
    </mat-card-content>
  </mat-card> -->

  <mat-card class="mcd-nav-card">
    <!-- <mat-card-header>
      <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text"
          >Market & BU Standards</mat-card-title
        >
      </div>
    </mat-card-header> -->
    <mat-card-content>
      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem2="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('marketStandards')" tabindex="1"
            [attr.aria-expanded]="accordionItem2.expanded">
            <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
            <div>
              <img src="../../../assets/images/blender 1.svg" alt=" Standards" class="accordian-item-heading" />
              <span>Equipments</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Standards" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'marketStandards'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'
                " />
            </span>
          </button>
          @if (expandedAccordion === "marketStandards") {
          <ul class="mcd-nav-list clearfix">


            <li *ngIf="userRole == userRoleEnum.GlobalAdmin && canAddEquipmentStandard">
              <a class="" routerLink="/add-eq-standards-global"
                (click)="navigateMenu('/add-eq-standards-global', 'add-eq-standards-global')"
                [class.active]="lastSelectedMenu === 'add-eq-standards-global'">

                <span class="nav-text">Add New Equipment Standard</span>
              </a>
            </li>

            <li *ngIf="userRole == userRoleEnum.AOWAdmin">
              <a class="" href="javascript:void(0)" routerLink="/add-abustandard"
                (click)="navigateMenu('/add-abustandard', 'add-abustandard')"
                [class.active]="lastSelectedMenu === 'add-abustandard'">
                <!-- <span class="nav-icon mcd-add-new-grbes"></span> -->
                <span class="nav-text">Add New BU Standard</span>
              </a>
            </li>

            <!-- National add-equipment nav hidden; Global Admin uses add-eq-standards-global above. -->
            <!-- <li *ngIf="CanAddNationalEquipmentStandard"> ... </li> -->



            <li *ngIf="viewEquipmentNationalStandard">
              <a class="" routerLink="/view-all-equipments" href="javascript:void(0)"
                (click)="navigateMenu('/view-all-equipments', 'view-all-equipments')" [class.active]="
                    lastSelectedMenu === 'view-all-equipments'
                  ">
                <!-- <span class="nav-icon mcd-view-all-equipment-standards"></span> -->
                <span class="nav-text">View All Equipment Standards</span>
              </a>
            </li>

            <li *ngIf="viewEquipmentObsoleteStandard">
              <a class="" routerLink="/view-all-obsolete-standards-list" href="javascript:void(0)"
                (click)="navigateMenu('/view-all-obsolete-standards-list', 'View All Obsolete Equipment')"
                [class.active]="lastSelectedMenu === 'View All Obsolete Equipment'">
                <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
                <span class="nav-text">View All Obsolete Equipment</span>
              </a>
            </li>


            <!-- <li *ngIf="viewMarketAdminPanel">
              <a class="" routerLink="/market-admin-panel"
                (click)="navigateMenu('/market-admin-panel', 'market-admin-panel')"
                [class.active]="lastSelectedMenu === 'market-admin-panel'" href="javascript:void(0)">
                <span class="nav-icon mcd-market-admin-panel"></span>
                <span class="nav-text">Admin Panel</span>
              </a>
            </li> -->
          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </mat-card-content>
  </mat-card>

  <mat-card class="mcd-nav-card" *ngIf="showExceptionsNav()">
    <!-- <mat-card-header>
      <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text">Exceptions</mat-card-title>
      </div>
    </mat-card-header> -->
    <mat-card-content>
      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem3="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('exceptionGovernance')" tabindex="1"
            [attr.aria-expanded]="accordionItem3.expanded">
            <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
            <div>
              <img src="../../../assets/images/page-2 3.svg" alt=" Standards" class="accordian-item-heading" />
              <span>Exceptions</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Standards" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'exceptionGovernance'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'
                " />
            </span>
          </button>
          @if (expandedAccordion === "exceptionGovernance") {
          <ul class="mcd-nav-list clearfix">
            <!-- <li *ngIf="viewAllAddendum">
                <a
                  routerLink="/equipment-addendum-list"
                  routerLinkActive="active"
                  (click)="navigateMenu('/equipment-addendum-list', 'equipment-addendum-list')"
                  [class.active]="lastSelectedMenu === 'equipment-addendum-list'"
                >
                  
                  <span class="nav-text">View All Equipment Exceptions</span>
                </a>
              </li> -->
            <li *ngIf="viewAllAddendum">
              <a routerLink="/addendum-list" (click)="navigateMenu('/addendum-list', 'addendum-list')"
                [class.active]="lastSelectedMenu === 'addendum-list'">
                <!-- <span class="nav-icon mcd-view-all-addendum"></span> -->
                <span class="nav-text">View all Exceptions</span>
              </a>
            </li>
            <li *ngIf="viewAllNotification">
              <a routerLink="/notification-list" (click)="navigateMenu('/notification-list', 'notification-list')"
                [class.active]="lastSelectedMenu === 'notification-list'">
                <!-- <span class="nav-icon mcd-view-all-notifications"></span> -->
                <span class="nav-text">View All Notifications</span>
              </a>
            </li>
          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </mat-card-content>
  </mat-card>
  <mat-card class="mcd-nav-card" *ngIf="viewGlobalAdminPanel">
    <mat-card-content>
      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItemAdmin="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('admin')" tabindex="1"
            [attr.aria-expanded]="expandedAccordion === 'admin'">
            <div>
              <img src="../../../assets/images/user-star 1.svg" alt=" Admin" class="accordian-item-heading" />
              <span>Admin</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Admin" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'admin'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'
                " />
            </span>
          </button>
          @if (expandedAccordion === 'admin') {
          <ul class="mcd-nav-list none-float-menu clearfix">
            <li *ngIf="viewAllUsefulLinks">
              <a routerLink="/view-as-different-role"
                (click)="navigateMenu('/view-as-different-role', 'view-as-different-role')"
                [class.active]="lastSelectedMenu === 'view-as-different-role'" href="javascript:void(0)">
                <span class="nav-text">View as Different Role</span>
              </a>
            </li>
            <li *ngIf="viewAllSuppliers">
              <a routerLink="/view-all-supplier-list"
                (click)="navigateMenu('/view-all-supplier-list', 'view-all-supplier-list')"
                [class.active]="lastSelectedMenu === 'view-all-supplier-list'" href="javascript:void(0)">
                <span class="nav-text">Suppliers</span>
              </a>
            </li>
            <li *ngIf="viewAllCategory">
              <a routerLink="/view-all-category-list"
                (click)="navigateMenu('/view-all-category-list', 'view-all-category-list')"
                [class.active]="lastSelectedMenu === 'view-all-category-list'" href="javascript:void(0)">
                <span class="nav-text">Categories</span>
              </a>
            </li>
            <li *ngIf="viewAllEquipmentType">
              <a routerLink="/view-all-equipment-type-list"
                (click)="navigateMenu('/view-all-equipment-type-list', 'view-all-equipment-type-list')"
                [class.active]="lastSelectedMenu === 'view-all-equipment-type-list'" href="javascript:void(0)">
                <span class="nav-text">Equipment Types</span>
              </a>
            </li>
            <li *ngIf="viewAllUser">
              <a routerLink="/view-all-user-list" (click)="navigateMenu('/view-all-user-list', 'view-all-user-list')"
                [class.active]="lastSelectedMenu === 'view-all-user-list'" href="javascript:void(0)">
                <span class="nav-text">User Management</span>
              </a>
            </li>
            <li *ngIf="viewAllUsefulLinks">
              <a routerLink="/view-all-useful-links"
                (click)="navigateMenu('/view-all-useful-links', 'view-all-useful-links')"
                [class.active]="lastSelectedMenu === 'view-all-useful-links'" href="javascript:void(0)">
                <span class="nav-text">Manage Useful Links</span>
              </a>
            </li>
            <li *ngIf="viewAllUsefulLinks">
              <a routerLink="/update-application-statement"
                (click)="navigateMenu('/update-application-statement', 'update-application-statement')"
                [class.active]="lastSelectedMenu === 'update-application-statement'" href="javascript:void(0)">
                <span class="nav-text">App Statement</span>
              </a>
            </li>
            <li>
              <a routerLink="/run/view-script" (click)="navigateMenu('/run/view-script', 'run/view-script')"
                [class.active]="lastSelectedMenu === 'run/view-script'" href="javascript:void(0)">
                <span class="nav-text">Run Links Analysis</span>
              </a>
            </li>
          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </mat-card-content>
  </mat-card>
  <mat-card class="mcd-nav-card" *ngIf="viewFaq || viewKeyContacts">
    <mat-card-header>
      <!-- <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text"
          >Tool Information</mat-card-title
        >
      </div> -->
    </mat-card-header>
    <mat-card-content>
      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem4="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('toolInformation')" tabindex="1"
            [attr.aria-expanded]="expandedAccordion === 'toolInformation'">
            <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
            <div>
              <img src="../../../assets/images/user-star 1.svg" alt=" Standards" class="accordian-item-heading" />
              <span>Tool Information</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Standards" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'toolInformation'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'
                " />
            </span>
          </button>
          @if (expandedAccordion === 'toolInformation') {
          <!-- <ul class="mcd-nav-list clearfix">
       
      </ul> -->

          <ul class="mcd-nav-list none-float-menu clearfix">
            <li *ngIf="viewKeyContacts">
              <a routerLink="/keycontact" routerLinkActive="active" (click)="navigateMenu('/keycontact', 'keycontact')"
                [class.active]="lastSelectedMenu === 'keycontact'">
                <!-- <span class="nav-icon mcd-key-contacts"></span> -->
                <span class="nav-text">Key Contacts</span>
              </a>
            </li>
            <li *ngIf="viewFaq">
              <a routerLink="/faq" routerLinkActive="active" (click)="navigateMenu('/faq', 'faq')"
                [class.active]="lastSelectedMenu === 'faq'">
                <!-- <span class="nav-icon mcd-faq"></span> -->
                <span class="nav-text">FAQ</span>
              </a>
            </li>

            <li *ngIf="viewFaq">
              <a href="https://spo.mcd.com/:f:/r/sites/atmcd_global/Global%20Development%20%20Design/GRBES/Training%20Materials?csf=1&web=1&e=WcPUFW"
                target="_blank">
                <!-- <span class="nav-icon mcd-training-link"></span> -->
                <span class="nav-text">Training Link</span>
              </a>
            </li>
          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </mat-card-content>
  </mat-card>

  <mat-card class="mcd-nav-card" *ngIf="viewFaq || viewKeyContacts || (usefulLinkList && usefulLinkList.usefullinks && usefulLinkList.usefullinks.length > 0)">
    <!-- <mat-card-header>
      <div class="mat-card-header-text">
        <mat-card-title class="mat-card-header-text"
          >Useful Links</mat-card-title
        >
      </div>
    </mat-card-header> -->
    <mat-card-content>
      <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem5="cdkAccordionItem" class="example-accordion-item">
          <button class="example-accordion-item-header" (click)="toggleAccordion('usefulLinks')" tabindex="1"
            [attr.aria-expanded]="expandedAccordion === 'usefulLinks'">
            <!-- <span class="nav-icon mcd-view-all-obsolete-standards"></span> -->
            <div>
              <img src="../../../assets/images/link-broken 1.svg" alt=" Standards" class="accordian-item-heading" />
              <span>Usefull Links</span>
            </div>

            <span>
              <img src="../../../assets/images/Container.svg" alt="Standards" [style.transition]="'transform 0.3s ease'"
                [style.transform]="
                  expandedAccordion === 'usefulLinks'
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)'                " />
            </span>
          </button>
          @if (expandedAccordion === "usefulLinks") {
          <ul *ngIf="usefulLinkList != null" class="mcd-nav-list none-float-menu clearfix">
            <li *ngFor="let item of usefulLinkList.usefullinks">
              <div *ngIf="item.url != ''">
                <a href="{{ item.url }}" target="_blank" [attr.title]="item.name" [matTooltip]="item.name" style="display: flex; align-items: center;">
                  <span class="nav-icon mcd-up"></span>
                  <span class="nav-text" style="width: 195px; text-align: left; white-space: nowrap; overflow: hidden; display: inline-block; color: #3F51B5; margin-top: 0; margin-left: 6px;">{{ item.name }}</span>
                </a>
              </div>

              <div *ngIf="item.url == ''">
                <a href="javascript:void(0);" (click)="onDownloadSelectedUsefulLinkAttachment(item)" [attr.title]="item.name" [matTooltip]="item.name" style="display: flex; align-items: center;">
                  <span class="nav-icon mcd-down"></span>
                  <span class="nav-text" style="width: 195px; text-align: left; white-space: nowrap; overflow: hidden; display: inline-block; color: #3F51B5; margin-top: 0; margin-left: 6px;">{{ item.name }}</span>
                </a>
              </div>
            </li>
            <!--<li>
    <a href="https://spo.mcd.com/sites/global_rsg/Pages/grbes.aspx" target="_blank">
      <span class="nav-icon mcd-equipment-capacity-tool"></span>
      <span class="nav-text">Equipment Capacity Tool</span>
    </a>
  </li>

  <li>
    <a href="https://rightsizingcalculator.com/" target="_blank">
      <span class="nav-icon mcd-cal"></span>
      <span class="nav-text">Right Sizing Calculator</span>
    </a>
  </li>
  <li>
    <a href="/Documents/GRBES - Standards Quick Reference Guide - Equipment - March 2021.pdf" target="_blank">
      <span class="nav-icon mcd-down"></span>
      <span class="nav-text">Core Equipment Quick Reference Guide</span>
    </a>
  </li>
  <li>
    <a href="https://mcd-gddg.com/development/foreignexchange/home" target="_blank">
      <span class="nav-icon mcd-up"></span>
      <span class="nav-text">Global Development Foreign Exchange</span>
    </a>
  </li>-->

            <!-- <li>-->
          </ul>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    </mat-card-content>
  </mat-card>
</div>